<template>
  <span>
    <span v-if="celldata.displayType == 'DollarReadOnly'">{{ celldata.value | currency(0) }}</span>

    <span v-if="celldata.displayType == 'PercentReadOnly'">{{ celldata.value | percent(percentDecimals) }}</span>

    <span v-if="celldata.displayType == 'NumberReadOnly'">{{ celldata.value | number(0) }}</span>

    <span v-if="celldata.displayType == 'DollarInput'">
      <div class="level-right">
        $<b-input
          type="number"
          v-model="celldata.value"
          @focus="$event.target.select()"
          @input="calculate()"
          size="is-small"
          style="width: 5em"
        ></b-input>
      </div>
    </span>

    <span v-if="celldata.displayType == 'PercentInput'">
      <div class="level-right">
        <b-input
          type="number"
          v-model="celldata.value"
          @focus="$event.target.select()"
          @input="calculate()"
          size="is-small"
          style="width: 5em"
        ></b-input>%
      </div>
    </span>

    <span v-if="celldata.displayType == 'NumberInput'">
      <div class="level-right">
        $<b-input
          type="number"
          v-model="celldata.value"
          @focus="$event.target.select()"
          @input="calculate()"
          size="is-small"
          style="width: 5em"
        ></b-input>
      </div>
    </span>

  </span>
</template>

<script>
export default {
  props: {
    celldata: {
      type: Object
    },
    percentDecimals: {
      type: Number,
      default: 2
    }
  },

  data() {
    return {};
  },

  methods: {
    calculate() {
      this.$parent.calculate();
    }
  }
};
</script>

<style>
</style>
